module.exports = "/assets/data/3e4b5b58faf63e8f817a77e76f9e228a-IM4.data.json";